import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrdersService } from '../../shared/orders.service';
import { Credits } from '../../../../models/Credits';
import moment from 'moment';

@Component({
    selector: 'app-credit-paper',
    templateUrl: './credit-paper.component.html',
    styleUrls: ['./credit-paper.component.scss'],
    standalone: false
})
export class CreditPaperComponent implements OnInit {

  public credit: Credits = new Credits();

  public validYear: number;

  constructor(private _activatedRoute: ActivatedRoute, private _ordersService: OrdersService) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      this._ordersService.getCreditByCreditCode(params['creditCode']).subscribe(result => {
        console.log(result);
        this.credit = result;
        this.validYear = parseInt(moment(this.credit.createdDate).format("YYYY")) + 1;
      });
    });
  }

}
